"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetL1Nodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_l1_nodes_query_1 = require("./get-l1-nodes.query");
const useGetL1Nodes = ({ productTreeNodeId }) => {
    const [fetchL1Nodes] = (0, react_2.useLazyQuery)(get_l1_nodes_query_1.GET_L1_NODES);
    const loadL1NodeOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { data } = yield fetchL1Nodes({
            variables: { productTreeId: productTreeNodeId },
        });
        if (!((_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.children))
            return [];
        return data.productTreeNode.children.map((node) => ({
            label: node.title,
            value: node.title,
        }));
    }), [fetchL1Nodes, productTreeNodeId]);
    return {
        loadL1NodeOptions,
    };
};
exports.useGetL1Nodes = useGetL1Nodes;
